import { io } from 'socket.io-client';
import {Utils} from "../utils";

const URL: any = process.env.REACT_APP_API_URL || 'https://ratesapi.mycontainers.ru';

const socket = io(URL,
  {
    transports: ['websocket', 'polling'],
    forceNew: true,
    upgrade: false,
    auth: {d: Utils.getUserInfo().id}
  });


socket.on('error', response => {
  console.log('errorAuth', response);
});

export default socket;

